import gql from 'graphql-tag';

import publicIntegrationItemFragment from '../fragments/publicIntegrationItemFragment';

export const queryPublicIntegrationItem = gql`
  query publicIntegrationItem(
    $accountID: DokkioID!
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    publicIntegrationItem(
      accountID: $accountID
      integrationID: $integrationID
      remoteID: $remoteID
    ) {
      ...publicIntegrationItemFragment
    }
  }
  ${publicIntegrationItemFragment}
`;

export default queryPublicIntegrationItem;
